import BaseStore from './BaseStore';
import rp from 'request-promise';
import config from '../config';
import { getToken } from '../components/Token';
import { getTenantHeaders } from '../components/TenantHeaders';
import { clearLocalStorage } from '../utils/common';
import moment from 'moment';
import { runInAction } from 'mobx';

const movementData = [
  { hour: 0 },
  { hour: 1 },
  { hour: 2 },
  { hour: 3 },
  { hour: 4 },
  { hour: 5 },
  { hour: 6 },
  { hour: 7 },
  { hour: 8 },
  { hour: 9 },
  { hour: 10 },
  { hour: 11 },
  { hour: 12 },
  { hour: 13 },
  { hour: 14 },
  { hour: 15 },
  { hour: 15 },
  { hour: 16 },
  { hour: 17 },
  { hour: 19 },
  { hour: 20 },
  { hour: 21 },
  { hour: 22 },
  { hour: 23 },
];
const chartData = [
  [
    'Walking',
    // '#fadbae',
    new Date(2019, 1, 1, 0, 1, 0),
    new Date(2019, 1, 1, 0, 1, 0),
  ],
  [
    'Standing',
    // '#b6d4d9',
    new Date(2019, 1, 1, 0, 1, 0),
    new Date(2019, 1, 1, 0, 1, 0),
  ],
  [
    'Walking',
    // '#fadbae',
    new Date(2019, 1, 1, 2, 0, 0),
    new Date(2019, 1, 1, 4, 30, 0),
  ],
  [
    'Standing',
    // '#b6d4d9',
    new Date(2019, 1, 1, 4, 30, 0),
    new Date(2019, 1, 1, 5, 0, 0),
  ],
  [
    'Sitting',
    // '#d2d9b0',
    new Date(2019, 1, 1, 5, 0, 0),
    new Date(2019, 1, 1, 5, 20, 0),
  ],
  [
    'Lying on right side',
    // '#d1cfe7',
    new Date(2019, 1, 1, 5, 20, 0),
    new Date(2019, 1, 1, 7, 0, 0),
  ],
  [
    'Lying on left side',
    // '#d1cfe7',
    new Date(2019, 1, 1, 7, 0, 0),
    new Date(2019, 1, 1, 8, 0, 0),
  ],
  [
    'Walking',
    // '#fadbae',
    new Date(2019, 1, 1, 8, 0, 0),
    new Date(2019, 1, 1, 10, 0, 0),
  ],
  [
    'Lying on back',
    // '#d1cfe7',
    new Date(2019, 1, 1, 10, 0, 0),
    new Date(2019, 1, 1, 12, 0, 0),
  ],
  [
    'Sitting',
    // '#d2d9b0',
    new Date(2019, 1, 1, 12, 0, 0),
    new Date(2019, 1, 1, 14, 20, 0),
  ],
  [
    'Lying on stomach',
    // '#d1cfe7',
    new Date(2019, 1, 1, 14, 20, 0),
    new Date(2019, 1, 1, 20, 0, 0),
  ],
  [
    'Sitting',
    // '#d2d9b0',
    new Date(2019, 1, 1, 20, 0, 0),
    new Date(2019, 1, 1, 24, 0, 0),
  ],
];
const alertData = [];
const locationData = [];
const batteryData = [];
const deviceData = [];

export class EventStore extends BaseStore {
  constructor() {
    super();
    this.observable({
      loading: false,
      loadingAlert: false,
      loadingActivity: false,
      loadingMovement: false,
      loadingAvailableDate: false,
      loadingLocation: false,
      loadingBattery: false,
      loadingDevice: false,
      chartData: [...chartData],
      movementData: [...movementData],
      locationData: [...locationData],
      batteryData: [...batteryData],
      deviceData: [...deviceData],
      date: '',
      dates: [],
      alerts: [...alertData],
      energy: 0,
      checkingTodayData: false,
      hasDataToday: false,
      dataPieChart: [],
      countTime: 0,
      highlightDate: [],
      includeDate: [],
      uniqueNames: [],
      deviceNames: [],
    });
  }

  resetSummary(dates) {
    runInAction(() => {
      const date = new Date();
      const dateFormate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
      this.chartData = this.calculateChartData([], dateFormate);
      this.movementData = this.calculateMovementData([], dateFormate);
      this.alerts = this.calculateAlertData([], dateFormate);
      this.locationData = [...locationData];
      this.deviceData = [...deviceData];
      this.energy = 0;
      this.dates = dates ? [] : this.dates;
      this.batteryData = this.calculateBattery([], dateFormate);
      this.countTime = 0;
      this.dataPieChart = [];
      this.highlightDate = dates ? [] : this.highlightDate;
      this.includeDate = dates ? [] : this.includeDate;
    });
  }

  async getSummary(id, date, queryOption) {
    const dateFormate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    runInAction(() => {
      this.date = date;
      this.chartData = this.calculateChartData([], dateFormate);
      this.movementData = this.calculateMovementData([], dateFormate);
      this.alerts = this.calculateAlertData([], dateFormate);
      if (queryOption.activity) {
        this.hasDataToday = true;
      }
    });
    try {
      this.setLoadingStatus(queryOption, true);

      let url = `${config.api.url}/${config.api.version}/eventlog/summary/${id}/date/${dateFormate}`;
      const res = await rp
        .get({
          uri: url,
          qs: queryOption,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: {
            ...getTenantHeaders(),
          },
        })
        .auth(null, null, true, getToken('id_token'));

      if (res && res.statusCode === 200) {
        runInAction(() => {
          const resp = res.body;

          if (queryOption.activity) {
            const chartData = resp['action'];
            this.chartData = this.calculateChartData(chartData, dateFormate);
            this.calculatePieChart(chartData);
          }

          if (queryOption.movement) {
            const movementData = resp['movement'];
            this.movementData = this.calculateMovementData(movementData, dateFormate);
          }

          if (queryOption.energy) {
            this.energy = resp['energy'];
          }

          if (queryOption.location) {
            const locationData = resp['location'];
            this.locationData = this.calculateLocation(locationData, dateFormate);
          }

          if (queryOption.alert) {
            const alerts = resp['alert'];
            this.alerts = this.calculateAlertData(alerts, dateFormate);
          }

          if (queryOption.availableDate) {
            const dates = resp['availableDate'];
            this.hasDataToday = false;

            const today = moment().startOf('d');
            const foundToday = dates.find((val) => {
              const datesame = moment(new Date(val));
              return datesame.isSame(today);
            });
            this.hasDataToday = foundToday ? true : false;
            this.checkingTodayData = false;

            const highlightDate = [];
            const includeDate = [];
            dates.forEach((val) => {
              const dt = new Date(val);
              highlightDate.push({
                'react-datepicker__quarter-text--highlighted': [dt],
              });
              includeDate.push(dt);
            });
            this.highlightDate = highlightDate;
            this.includeDate = includeDate;
          }

          if (queryOption.battery) {
            const batteryData = resp['battery'];
            this.batteryData = this.calculateBattery(batteryData, dateFormate);
          }

          if (queryOption.device) {
            const deviceData = resp['device'];
            this.deviceData = this.calculateDevice(deviceData, dateFormate);
          }
        });
      }
    } catch (err) {
      if (err.statusCode === 401) {
        clearLocalStorage();
        window.location.href = '/login';
      }
      throw err;
    } finally {
      this.setLoadingStatus(queryOption, false);
    }
  }

  async getSummaryFromCache(id, date, queryOption) {
    const dateFormate = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    runInAction(() => {
      this.checkingTodayData = true;
      this.date = date;
      if (localStorage.getItem('role_id') === '1') {
        queryOption.admin = true;
      }

      if (queryOption.availableDate) {
        this.loadingAvailableDate = true;
        this.hasDataToday = false;
      }
    });

    if (config.cache) {
      try {
        this.setLoadingStatus(queryOption, true);

        let url = `${config.api.url}/${config.api.version}/eventlog/summary/${id}/date/${dateFormate}/cache`;
        const res = await rp
          .get({
            uri: url,
            qs: queryOption,
            authorization: true,
            resolveWithFullResponse: true,
            json: true,
            headers: {
              ...getTenantHeaders(),
            },
          })
          .auth(null, null, true, getToken('id_token'));

        if (res && res.statusCode === 200) {
          const resp = res.body || {};
          if (Object.keys(resp).length === 0) {
            this.loadingAlert = true;
            this.loadingActivity = true;
            this.loadingMovement = true;
            this.loadingLocation = true;
            this.loadingDevice = true;
            await this.getSummary(id, this.date, queryOption);
          } else {
            runInAction(() => {
              if (queryOption.activity) {
                this.chartData = resp['action'];
              }

              if (queryOption.movement) {
                this.movementData = resp['movement'];
              }

              if (queryOption.energy) {
                this.energy = resp['energy'];
              }

              if (queryOption.location) {
                this.locationData = resp['location'];
              }

              if (queryOption.alert) {
                this.alerts = resp['alert'];
              }

              if (queryOption.availableDate) {
                if (resp['availableDate'].length > 0) {
                  const dates = resp['availableDate'];
                  this.hasDataToday = false;

                  const today = moment().startOf('d');
                  const foundToday = dates.find((val) => {
                    const datesame = moment(new Date(val));
                    return datesame.isSame(today, 'day');
                  });
                  this.hasDataToday = foundToday ? true : false;
                  this.checkingTodayData = false;

                  const highlightDate = [];
                  const includeDate = [];
                  dates.forEach((val) => {
                    const dt = new Date(val);
                    highlightDate.push({
                      'react-datepicker__quarter-text--highlighted': [dt],
                    });
                    includeDate.push(dt);
                  });
                  this.highlightDate = highlightDate;
                  this.includeDate = includeDate;
                } else {
                  this.getSummary(id, this.date, { availableDate: true });
                }
              }

              if (queryOption.battery) {
                this.batteryData = resp['battery'];
              }

              if (queryOption.device) {
                this.deviceData = resp['device'];
              }
            });
          }
        }
      } catch (err) {
        if (err.statusCode === 401) {
          clearLocalStorage();
          window.location.href = '/login';
        }
        this.getSummary(id, this.date, queryOption);
        throw err;
      } finally {
        this.setLoadingStatus(queryOption, false);
      }
    } else {
      this.getSummary(id, this.date, queryOption);
    }
  }

  setLoadingStatus(queryOption, status) {
    runInAction(() => {
      if (queryOption.alert) {
        this.loadingAlert = status;
      }
      if (queryOption.activity) {
        this.loadingActivity = status;
      }
      if (queryOption.movement) {
        this.loadingMovement = status;
      }
      if (queryOption.location) {
        this.loadingLocation = status;
      }
      if (queryOption.battery) {
        this.loadingBattery = status;
      }
      if (queryOption.device) {
        this.loadingDevice = status;
      }
      if (queryOption.availableDate) {
        this.loadingAvailableDate = status;
      }
    });
  }

  getUTCDateTime(dateTime) {
    return dateTime.getTime() - dateTime.getTimezoneOffset() * 60 * 1000;
  }

  getNumberActivity(eventName) {
    let value = 7;
    switch (eventName) {
      case 'Lying on stomach':
        value = 6;
        break;
      case 'Lying on back':
        value = 5;
        break;
      case 'Lying on left side':
        value = 4;
        break;
      case 'Lying on right side':
        value = 3;
        break;
      case 'Sitting':
        value = 2;
        break;
      case 'Standing':
        value = 1;
        break;
      case 'Walking':
        value = 0;
        break;
      default:
        value = 7;
        break;
    }
    return value;
  }

  getAlertSerieData(alerts, alertType, showInLegend = true) {
    let color = '#ffffff';
    let name = ' ';

    switch (alertType) {
      case 501:
        color = '#f06b05';
        name = 'Getup';
        break;
      case 502:
        color = '#bab51a';
        name = 'Movement';
        break;
      case 506:
        color = '#256338';
        name = 'Not Turn';
        break;
      case 507:
        color = '#05f0f0';
        name = 'No Movement For';
        break;
      case 508:
        color = '#f00505';
        name = 'Fall';
        break;
      case 509:
        color = '#055bf0';
        name = 'Exit';
        break;
      case 510:
        color = '#f0059a';
        name = 'Get Near';
        break;
      case 511:
        color = '#460aad';
        name = 'Walking';
        break;
      case 514:
        color = '#A67a0d';
        name = 'Emergency';
        break;
      default:
        break;
    }

    const datas = (alerts || []).map((val) => {
      return {
        x: this.getUTCDateTime(new Date(val.timestamp)),
        y: 0,
        color,
        name,
        label: name,
        description: val.alertInfo ? val.alertInfo : '',
      };
    });

    const serieData = {
      name,
      showInLegend: !showInLegend ? showInLegend : alerts && alerts.length > 0,
      color,
      dataLabels: {
        allowOverlap: false,
        format:
          '<span style="color:{point.color}">● </span><span style="font-weight: bold;" > ' +
          '{point.x:%A, %b %d, %H:%M:%S}</span><br/>{point.label}',
      },
      marker: {
        symbol: 'circle',
        radius: 4,
      },
      enableMouseTracking: !showInLegend ? showInLegend : alerts && alerts.length > 0,
      data: datas,
    };

    return serieData;
  }

  calculatePieChart(chartData) {
    // 1st
    let sumDateTime = chartData.map((value) => {
      let data = {};
      data['name'] = value.eventName;
      data['value'] = (new Date(value.end).getTime() - new Date(value.start).getTime()) / 100;
      return data;
    });

    // 2nd
    const uniqueArrayWithCounts = sumDateTime.reduce((accum, val) => {
      const dupeIndex = accum.findIndex((arrayItem) => arrayItem.name === val.name);
      if (dupeIndex === -1) {
        accum.push({
          value: val.value,
          ...val,
        });
      } else {
        accum[dupeIndex].value += val.value;
      }
      return accum;
    }, []);

    // 3th

    const dataAllActions = uniqueArrayWithCounts.map((val) => {
      let second = parseFloat(val.value / 10).toFixed(0);
      let hours = val.value / 60 / 60;
      let minutes = val.value % 60;
      let time = hours / 10 + '.' + minutes;
      let number = parseFloat(time);
      this.countTime = +this.countTime + +second;
      return [val.name, parseFloat(number.toFixed(2))];
    });

    // 4th
    if (dataAllActions.length > 0) {
      const groupedActions = ['Lying on right side', 'Lying on left side', 'Lying on back', 'Lying on stomach'];
      const allLying = (dataAllActions || []).filter((action) => groupedActions.includes(action[0]));
      const allLyingSummaryTime = (allLying || []).reduce((total, item) => total + (item[1] || 0), 0);

      this.dataPieChart = (dataAllActions || []).filter((action) => !groupedActions.includes(action[0]));
      this.dataPieChart.push(['Lying', allLyingSummaryTime]);
    } else {
      this.dataPieChart = [];
    }
  }

  calculateAlertData(alerts, date) {
    let alertResult = [];
    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);

    const mockStart = { timestamp: startDate, alertType: 0 };
    const mockEnd = { timestamp: endDate, alertType: 0 };

    const mockAlert = this.getAlertSerieData([mockEnd, mockStart], 0, alerts.length === 0);
    alertResult.push(mockAlert);

    const alertTypes = [501, 502, 506, 507, 508, 509, 510, 511, 514];
    alertTypes.forEach((type) => {
      const tmps = this.getAlertSerieData(
        (alerts || []).filter((value) => value.alertType === type),
        type,
        true,
      );
      tmps && alertResult.push(tmps);
    });

    return alertResult;
  }

  calculateChartData(activity, date) {
    let activityResult = [];

    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);

    activityResult.push({
      x: this.getUTCDateTime(startDate),
      x2: this.getUTCDateTime(startDate) + 1,
    });

    const y = [0, 1, 2, 3, 4, 5, 6];
    y.forEach((val) => {
      activityResult.push({
        y: val,
        x: this.getUTCDateTime(startDate),
        x2: this.getUTCDateTime(startDate) + 1,
      });
    });

    activity.forEach((val) => {
      activityResult.push({
        x: this.getUTCDateTime(new Date(val.start)),
        x2: this.getUTCDateTime(new Date(val.end)),
        y: this.getNumberActivity(val.eventName),
        loc: val.location,
      });
    });

    activityResult.push({
      x: this.getUTCDateTime(endDate),
      x2: this.getUTCDateTime(endDate),
    });

    return activityResult;
  }

  calculateMovementData(movement, date) {
    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);

    let movementResult = [];
    movementResult.push([this.getUTCDateTime(startDate), 0]);
    let i = 0;
    movement.forEach((val) => {
      i++;
      if (i === movement.length) {
        movementResult.push([this.getUTCDateTime(new Date(val.timestamp)), +val.value]);
        movementResult.push([this.getUTCDateTime(new Date(val.timestamp)), 0]);
      } else {
        movementResult.push([this.getUTCDateTime(new Date(val.timestamp)), +val.value]);
      }
    });
    movementResult.push([this.getUTCDateTime(endDate), 0]);

    return movementResult;
  }

  calculateLocation(location, date) {
    let locationResult = [];
    let routerNames = [];
    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);

    if (location.length > 0) {
      locationResult.push({
        x: this.getUTCDateTime(startDate),
        x2: this.getUTCDateTime(startDate) + 1,
      });
      location.forEach((val) => {
        val.location = !val.location ? 'Unknown' : val.location;
        routerNames.push(val.location);

        locationResult.push({
          x: this.getUTCDateTime(new Date(val.start)),
          x2: this.getUTCDateTime(new Date(val.end)),
          y: val.value,
        });
      });
      this.uniqueNames = routerNames.filter((val, id, array) => array.indexOf(val) === id);

      locationResult.push({
        x: this.getUTCDateTime(endDate),
        x2: this.getUTCDateTime(endDate),
      });
    }

    return locationResult;
  }

  calculateBattery(battery, date) {
    let batteryResult = [];
    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);

    if (battery.length > 0) {
      batteryResult.push({
        x: this.getUTCDateTime(startDate),
      });

      battery.forEach((val) => {
        batteryResult.push({
          x: this.getUTCDateTime(new Date(val.start)),
          y: parseInt(val.value),
        });
      });

      batteryResult.push({
        x: this.getUTCDateTime(endDate),
      });
    }

    return batteryResult;
  }

  calculateDevice(device, date) {
    let deviceResult = [];
    let deviceNames = [];
    let startDate = new Date(`${date} 00:00`);
    let endDate = new Date(`${date} 23:59`);

    // get unique of devices
    const uniqDevices = [];
    device.forEach((element) => {
      if (!uniqDevices.includes(element.device)) {
        uniqDevices.push(element.device);
      }
    });

    if (device.length > 0) {
      deviceResult.push({
        x: this.getUTCDateTime(startDate),
        x2: this.getUTCDateTime(startDate) + 1,
      });
      device.forEach((val, index) => {
        val.device = !val.device ? 'Unknown' : val.device;
        deviceNames.push(val.device);

        deviceResult.push({
          x: this.getUTCDateTime(new Date(val.start)),
          x2: this.getUTCDateTime(new Date(val.end)),
          y: uniqDevices.indexOf(val.device),
        });
      });
      this.deviceNames = deviceNames.filter((val, id, array) => array.indexOf(val) === id);

      deviceResult.push({
        x: this.getUTCDateTime(endDate),
        x2: this.getUTCDateTime(endDate),
      });
    }
    return deviceResult;
  }
}

export default new EventStore();
